module.exports = __webpack_public_path__ + "img/98.e8a55727.jpg";